import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import queryString from 'query-string';
import pick from 'lodash.pick';
import omit from 'lodash.omit';
import isEmpty from 'lodash.isempty';
import areOptionsEqual from '@utils/areOptionsEqual';
import {getValidPackagesParams} from '@utils/getValidPackagesParams';
import {selectUserAttributes} from '@components/Login/userSlice';
import {DEFAULT_TRANSACTIONS_OPTIONS, TRANSACTIONS_PATH} from '../../constants';
import {
    fetchTransactions,
    selectOptions,
    selectTransactions,
    selectTransactionsPerPage,
    setOptions
} from '../components/Transactions/transactionsSlice';

export default function useTransactionsPageNavigate(onSuccess, navigateImmediately) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const options = useSelector(selectOptions);
    const transactions = useSelector(selectTransactions);
    const {transactionsPerPage: transactionUserAttribute} = useSelector(selectUserAttributes);
    const storedTransactionsPerPage = useSelector(selectTransactionsPerPage);
    const transactionsPerPage = transactionUserAttribute || storedTransactionsPerPage;

    return async (pageOptions = {}, shouldResetPages) => {
        const newOptions = {
            ...DEFAULT_TRANSACTIONS_OPTIONS,
            ...options,
            ...getValidPackagesParams(pageOptions)
        };

        if (shouldResetPages) {
            newOptions.from = DEFAULT_TRANSACTIONS_OPTIONS.from;
            newOptions.to = transactionsPerPage;
        }

        const filteredNewOptions = pick(newOptions, [
            'from',
            'to',
            'sort',
            'dir',
            'query',
            'search',
            'predefined',
            'updatedSinceDays'
        ]);
        const newQuery = queryString.stringify(omit(filteredNewOptions, ['query']));

        const previousOptions = pick(options, Object.keys(filteredNewOptions));
        const isSilent = !isEmpty(transactions)
            && areOptionsEqual(filteredNewOptions, previousOptions);

        dispatch(setOptions(filteredNewOptions));

        if (navigateImmediately) {
            navigate(`${TRANSACTIONS_PATH}/${filteredNewOptions.query}?${newQuery}`);
        }

        const wasSuccessful = await dispatch(fetchTransactions({shouldUseGlobalLoading: true, isSilent}));

        if (wasSuccessful) {
            if (onSuccess) {
                onSuccess();
            }
            if (!navigateImmediately) {
                navigate(`${TRANSACTIONS_PATH}/${filteredNewOptions.query}?${newQuery}`);
            }
        }
    };
}
